import BaseState from 'Engine/base/states/BaseState';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';

export default class ShowBigWinState extends BaseState {
  constructor(stateData) {
    super(stateData);
  }

  addListeners() {
    super.addListeners();
    GlobalDispatcher.add('bigWinContainer:stopState', this.complete, this);
  }

  complete() {
    if (this.active) {
      super.complete();
    }
  }

  onEnd() {
    super.onEnd();
  }
}
